import Vue from 'vue';
import helpers from '../../utils/helpers';

export default (type = 'single', params = {}) => (
    new Promise((resolve, reject) => {
      let request = null;
      if (type === 'validate') {
        request = Vue.$http.get(helpers.buildUrl('/reports/turnover/client/validate/bulk', params));
      } else if (type === 'multiple') {
        request = Vue.$http.get(helpers.buildUrl('/reports/turnover/client/download/bulk', params), { responseType: 'arraybuffer' });
      } else {
        request = Vue.$http.get(helpers.buildUrl(`reports/turnover/client/${params.id}`, params), { responseType: 'blob' });
      }
      request.then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    })
);



// WEBPACK FOOTER //
// ./src/app/services/report/downloadTurnOverPdf.js